<template>
    <div class="container">
        <div class="row my-5">
            <div class="col-12">
                <!-- users aNewItem handle -->
                <div class="card bg-light">
                    <div class="card-body">
                        <form v-if="user">
                            <dl class="row">
                                <dt class="col-lg-8 col-md-7 col-sm-6 col-12">
                                    <h3 class="mb-3 text-dark-green nav-settings-head">Handle</h3>
                                </dt>
                                <dd class="col-lg-4 col-md-5 col-sm-6 col-12 d-none d-sm-block">
                                    <div class="row">
                                        <div class="col-5">
                                            <router-link :to="{ name: 'profile' }" class="btn btn-light btn-sm bg-white form-control">Go Back</router-link>
                                        </div>
                                        <div class="col-7">
                                            <button @click.prevent="saveHandle" class="loadn btn btn-dark-green btn-sm form-control">Save Changes</button>
                                        </div>
                                    </div>
                                </dd>
                            </dl>
                            <dl v-if="msg !== ''" class="row mb-5">
                                <dd class="offset-md-4 col-md-8 offset-0 col-12">
                                    <div :class="`alert alert-${color} text-center mb-n4 p-1`" role="alert">
                                        <i :class="`far fa-${emoji}`"></i> {{ msg }}
                                    </div>
                                </dd>
                            </dl>
                            <dl class="row">
                                <dt class="col-md-4 col-12 mb-2">My aNewItem Handle<span class="text-danger">*</span></dt>
                                <dd class="col-md-8 col-12">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <div class="input-group-text bg-light text-dark-green font-weight-bold">
                                                <i class="fas fa-at fa-md mt-1"></i>{{user.userHandle}}
                                            </div>
                                        </div>
                                        <input type="text" v-model="userHandle" :placeholder="userHandleNote" class="form-control no-lines">
                                    </div>    
                                </dd>
                            </dl>
                            <dl v-if="suggestions" class="row mb-5">
                                <dd class="offset-md-4 col-md-8 offset-0 col-12">
                                    <div class="alert bg-white text-center mb-n4 p-1" role="alert">
                                        <span v-for="(x,i) in suggestionsArr" :key="i" class="text-muted mx-2">{{x}}</span>
                                    </div>
                                </dd>
                            </dl>
                            <dl class="row d-sm-none">
                                <dd class="col-12">
                                    <hr>
                                    <div class="row">
                                        <div class="col-5">
                                            <router-link :to="{ name: 'profile' }" class="btn btn-light btn-sm bg-white form-control">Go Back</router-link>
                                        </div>
                                        <div class="col-7">
                                            <button @click.prevent="saveHandle" class="loadn btn btn-dark-green btn-sm form-control">Save Changes</button>
                                        </div>
                                    </div>
                                </dd>
                            </dl>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <!-- users referrals list -->
        <div class="row my-5">
            <div class="col-12">
                <div class="card bg-white">
                    <div class="card-body">
                        <form v-if="user">
                            <dl class="row mb-3">
                                <dt class="col-md-4 col-12">
                                    <h3 class="text-dark-green nav-settings-head">My Referrals</h3>
                                </dt>
                                <dd v-if="myReferralLink" class="col-md-8 col-12 text-right d-md-block d-none">
                                    <div class="add-ellipsis">
                                        <span @click.prevent="copyURL" class="referral-link" ref="myRefLink">{{myReferralLink}}</span>
                                        <span v-if="copied" class="referral-link ml-2">Copied!</span>
                                        <i v-else @click.prevent="copyURL" title="click to copy your referral link" 
                                        class="far fa-copy text-dark-green fa-lg ml-2 clickable"></i>
                                    </div>
                                </dd>
                                <dd v-if="myReferralLink" class="col-md-8 col-12 text-center d-md-none">
                                    <div class="add-ellipsis mt-2">
                                        <span v-if="copied" class="referral-link mr-2">Copied!</span>
                                        <i v-else @click.prevent="copyURL" title="click to copy your referral link" 
                                        class="far fa-copy text-dark-green fa-lg mr-2 clickable"></i>
                                        <span @click.prevent="copyURL" class="referral-link" ref="myRefLink">{{myReferralLink}}</span>
                                    </div>
                                </dd>
                            </dl>
                            <div class="table-responsive">
                                <table class="table table-striped">
                                    <thead class="bg-silver">
                                        <tr>
                                            <th scope="col">No.</th>
                                            <th scope="col">Users</th>
                                            <th scope="col">Referred</th>
                                            <th scope="col">Items</th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="myReferredUsers">
                                        <tr v-for="(referred, i) in myReferredUsers" :key="i">
                                            <td>{{i + 1}}.</td>
                                            <td v-if="referred.handle" class="text-capitalize">
                                                <router-link :to="{ name: 'user-handle', params: { handle: referred.handle } }"> 
                                                    {{referred.name}} 
                                                    <span class="text-dark-green text-lowercase mx-1">@{{referred.handle}}</span>
                                                </router-link> 
                                            </td>
                                            <td v-else>{{referred.email}}</td>
                                            <td>{{referred.joined | moment("MMM D 'YY")}}</td>
                                            <td>{{referred.active}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { copyTextFxn } from '@/store/dry'
export default {
    name: "Handle",
    data() {
        return {
            userHandle: '',
            suggestionsArr: [],
            suggestions: false,
            copied: false,
            msg: '',
            color: '',
            emoji: 'frown'
        }
    },
    methods: {
        ...mapActions(['updateHandle', 'handleSuggestions']),
        saveHandle(){
            this.color = "danger"
            this.emoji = "frown"
            this.suggestions = false
            if(this.userHandle === ''){ this.msg = "A handle is required"; return }
            if(this.userHandle.length < 3){ this.msg = "A good handle should be at least 3 chars long"; return }
            if(this.userHandle === this.user.userHandle){ this.msg = `Hey ${this.user.name}, that is your current handle`; return }
            this.userHandle = this.userHandle.split(" ").join("")
            let userObj = {
                userId: this.user._id,
                userHandle: this.removeAtSign(this.userHandle)
            }
            this.updateHandle(userObj)
            .then(() => {
                this.color = "success"
                this.emoji = "smile"
                this.msg = `Congratulations! '${userObj.userHandle}' has been set as your new handle!`
                this.userHandle = ''
            }).catch((e) => {
                this.msg = "This handle is already taken, try any suggestion below."
                
                // check db for other available handle suggestions
                this.suggestions = true
                let userObj = {
                    name: this.user.name
                }
                this.handleSuggestions(userObj)
                .then((data) => {
                    this.suggestionsArr = data
                })
                .catch((e) => {
                    this.suggestionsArr = []
                })
            })
        },
        removeAtSign(val) {
            // ensure it doesn't begin with @ sign
            val = val.toLowerCase()
            let atSymbol = val.slice(0, 1) 
            if(atSymbol !== "@"){ return val }
            else { return val.slice(1, val.length) }
        },
        copyURL() {
            this.copied = true
            setTimeout(() => {
                this.copied = false
            }, 1000)
            copyTextFxn(this.$refs.myRefLink.innerText)
        }
    },
    computed: {
        ...mapGetters(['user', 'myReferrals', 'authenticated']),
        myReferralLink() {
            if(this.user && this.user.userHandle){
                return `${process.env.VUE_APP_CLT_URL}/${this.user.userHandle}/refer-a-friend`
            }
            return false
        },
        userHandleNote() {
            if(this.user && !this.user.userHandle){
                return "create a handle"   
            }
            return "modify your handle"
        },
        myReferredUsers() {
            if(this.myReferrals && this.myReferrals.length) {
                return this.myReferrals
            }
            return false
        }
    }
}
</script>